/*
 * Copyright (c) 2025. Bolmate B.V.
 */
import './style/iconWithLabel.scss';

import {AwesomeIcon} from '@dvrd/dvr-controls';
import {IconName, IconPrefix} from '@fortawesome/fontawesome-svg-core';
import React, {useMemo} from 'react';
import classNames from 'classnames';

interface Props extends React.ComponentProps<any> {
    label: string;
    name: IconName;
    labelClassName?: string;
    iconClassName?: string;
    prefix?: IconPrefix;
}

export default function IconWithLabel(props: Props) {
    const {label, labelClassName, className, iconClassName} = props;
    const reactProps = useMemo(() => {
        const reactProps = {...props};
        delete reactProps['labelClassName'];
        delete reactProps['iconClassName'];
        return reactProps;
    }, []);
    return <div className={classNames('icon-with-label', className)}>
        <AwesomeIcon {...reactProps} className={iconClassName}/>
        <label className={classNames('icon-title', labelClassName)}>{label}</label>
    </div>
}